export default __webpack_public_path__ + "static/media/aws-logo.6d36a9bec4fdb878395692fb6ff1c8a5.png";